"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGroupContact = isGroupContact;
function isGroupContact(contact) {
  return "members" in contact;
}

/**
 * Omitting options since we are redefining hem a bit
 * Omitting isSearchabe, as it will always be true
 */

/**
 * Omitting options since we are redefining hem a bit
 * Omitting isSearchabe, as it will always be true
 */
//# sourceMappingURL=types.js.map